"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component = _interopRequireDefault(require("../../Component"));

var _main = _interopRequireDefault(require("../templates/main"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "animationEnd", function () {
      var userCallback = _this.state.userCallback;

      if (typeof userCallback === 'function') {
        userCallback();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTargetClick", function () {
      var _this$props = _this.props,
          onTargetClick = _this$props.onTargetClick,
          closeOnTargetClick = _this$props.closeOnTargetClick;

      if (typeof onTargetClick === 'function') {
        closeOnTargetClick ? _this.close(onTargetClick) : onTargetClick();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "close", function (userCallback) {
      var animateOverlay = _this.props.animateOverlay;

      if (typeof userCallback === 'function' && (typeof animateOverlay === 'boolean' && !animateOverlay || (0, _typeof2["default"])(animateOverlay) === 'object' && typeof animateOverlay.exit !== 'undefined' && !animateOverlay.exit)) {
        userCallback();
      } else {
        _this.setState({
          out: true,
          userCallback: userCallback
        });
      }
    });
    _this.state = {
      out: false,
      userData: null
    };
    return _this;
  }

  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  className: '',
  style: {},
  animateOverlay: true,
  closeOnTargetClick: true
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  style: _propTypes["default"].object,

  /**
   * ф-ция для кастомного контента который может закрывать TutorialHint посредством коллбека - close
   */
  hintRender: _propTypes["default"].func,
  className: _propTypes["default"].string,

  /**
   * ВАЖНО! Если передан - target перекрывается прозрачным div'ом, который перехватывает событие onClick в зоне target'a
   */
  onTargetClick: _propTypes["default"].func,

  /**
   * true - закрытие компонента по клику на target (только если передан onTargetClick)
   */
  closeOnTargetClick: _propTypes["default"].bool,

  /**
   * задает анимировать ли закрытие и/или открытие
   */
  animateOverlay: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].shape({
    exit: _propTypes["default"].bool,
    appear: _propTypes["default"].bool
  })]),

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.zOverlay
     */
    zIndexRoot: _propTypes["default"].number,

    /**
     * @default palette.elSecondaryAccent
     */
    overlayColor: _propTypes["default"].string,

    /**
     * @default 0.87
     */
    overlayOpacity: _propTypes["default"].string,

    /**
     * @default palette.gutter * 65 + 'px'
     */
    overlaySize: _propTypes["default"].string,

    /**
     * @default 50%
     */
    overlayPositionTop: _propTypes["default"].string,

    /**
     * @default 50%
     */
    overlayPositionLeft: _propTypes["default"].string,

    /**
     * @default translate(-50%, -50%)
     */
    overlayPositionTransform: _propTypes["default"].string,

    /**
     * @default center
     */
    overlayTransformOrigin: _propTypes["default"].string,

    /**
     * @default null
     */
    overlayAnimationName: _propTypes["default"].any,

    /**
     * @default null
     */
    overlayAnimationNameOut: _propTypes["default"].any,

    /**
     * @default .5s
     */
    overlayAnimationDuration: _propTypes["default"].string,

    /**
     * @default linear
     */
    overlayAnimationTimingFunction: _propTypes["default"].string,

    /**
     * @default 1
     */
    overlayAnimationIterationCount: _propTypes["default"].string,

    /**
     * @default forwards
     */
    overlayAnimationFillMode: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    pulsarColor: _propTypes["default"].string,

    /**
     * @default palette.gutter * 6 + 'px'
     */
    pulsarSize: _propTypes["default"].string,

    /**
     * @default null
     */
    pulsarAnimationName: _propTypes["default"].any,

    /**
     * @default none
     */
    pulsarAnimationNameOut: _propTypes["default"].string,

    /**
     * @default 1.2s
     */
    pulsarAnimationDuration: _propTypes["default"].string,

    /**
     * @default 0s
     */
    pulsarAnimationDelay: _propTypes["default"].string,

    /**
     * @default linear
     */
    pulsarAnimationTimingFunction: _propTypes["default"].string,

    /**
     * @default infinite
     */
    pulsarAnimationIterationCount: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    placeholderColor: _propTypes["default"].string,

    /**
     * @default palette.gutter * 6 + 'px'
     */
    placeholderSize: _propTypes["default"].string,

    /**
     * @default null
     */
    placeholderAnimationName: _propTypes["default"].any,

    /**
     * @default none
     */
    placeholderAnimationNameOut: _propTypes["default"].string,

    /**
     * @default 1.2s
     */
    placeholderAnimationDuration: _propTypes["default"].string,

    /**
     * @default linear
     */
    placeholderAnimationTimingFunction: _propTypes["default"].string,

    /**
     * @default infinite
     */
    placeholderAnimationIterationCount: _propTypes["default"].string,

    /**
     * @default null
     */
    contentWrapperAnimationName: _propTypes["default"].any,

    /**
     * @default null
     */
    contentWrapperAnimationNameOut: _propTypes["default"].any,

    /**
     * @default .3s
     */
    contentWrapperAnimationDuration: _propTypes["default"].string,

    /**
     * @default linear
     */
    contentWrapperAnimationTimingFunction: _propTypes["default"].string,

    /**
     * @default 1
     */
    contentWrapperAnimationIterationCount: _propTypes["default"].string,

    /**
     * @default forwards
     */
    contentWrapperAnimationFillMode: _propTypes["default"].string,

    /**
     * @default -${palette.gutter * 13}px
     */
    hintLeft: _propTypes["default"].string,

    /**
     * @default ${palette.gutter * 6}px
     */
    hintTop: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    wrapperBackgroundColor: _propTypes["default"].string,

    /**
     * @default pointer
     */
    onClickInterceptorCursor: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'TutorialHint');
var _default = Main;
exports["default"] = _default;